import { FC, PropsWithChildren, ReactElement } from 'react'
import clsx from 'clsx'
import styles from './index.module.sass'

interface Props {
  className?: string;
  isPage?: boolean;
  titleBar?: ReactElement<unknown, 'TitleBar'>;
  bottomBar?: ReactElement<unknown, 'bottomBar'>;
}

const Scaffold: FC<PropsWithChildren<Props>> = ({
  className = '',
  isPage,
  titleBar,
  children,
  bottomBar
}) => {
  return (
    <div
      className={styles.scaffold}
      style={{ minHeight: isPage ? '100vh' : '100%' }}
    >
      {titleBar ?? <header />}
      <main className={styles.main}>
        <div className={clsx(className, styles.mainContent)}>{children}</div>
      </main>
      {bottomBar ?? <footer />}
    </div>
  )
}

export default Scaffold
